import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Subscription, takeUntil } from 'rxjs';

import { PrequalService } from '../services/prequal.service';
import { Unsubscribe } from '../shared/classes/unsubscribe.class';

@Component({
  selector: 'capq-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  standalone: false,
})
export class ProgressBarComponent
  extends Unsubscribe
  implements OnInit, OnChanges
{
  @Input() set setActiveStep(step: number) {
    this.activeStep = step;
    this.notShowingErrorPage = this.activeStep !== -1;
  }

  activeStep = 1;
  notShowingErrorPage = true;
  subscription: Subscription[] = [];

  isMobileView = false;

  contents = [
    {
      isStepComplete: false,
      id: 1,
      name: 'Personal',
      completedImage: 'assets/images/checkmark_checked.svg',
      disabledImage: 'assets/images/checkmark_unchecked.png',
    },
    {
      isStepComplete: false,
      id: 2,
      name: 'Residence',
      completedImage: 'assets/images/checkmark_checked.svg',
      disabledImage: 'assets/images/checkmark_unchecked.png',
    },
    {
      isStepComplete: false,
      id: 3,
      name: 'Income',
      completedImage: 'assets/images/checkmark_checked.svg',
      disabledImage: 'assets/images/checkmark_unchecked.png',
    },
    {
      isStepComplete: false,
      id: 4,
      name: 'Accounts',
      completedImage: 'assets/images/checkmark_checked.svg',
      disabledImage: 'assets/images/checkmark_unchecked.png',
    },
    {
      isStepComplete: false,
      id: 5,
      name: 'Identification',
      completedImage: 'assets/images/checkmark_checked.svg',
      disabledImage: 'assets/images/checkmark_unchecked.png',
    },
    {
      isStepComplete: false,
      id: 6,
      name: 'Summary',
      completedImage: ' ',
      disabledImage: ' ',
    },
  ];

  constructor(
    private responsive: BreakpointObserver,
    private prequalService: PrequalService
  ) {
    super();
  }
  ngOnChanges(): void {
    if (this.activeStep > 1) {
      this.contents[this.activeStep - 2].isStepComplete = true;
    }
  }

  ngOnInit(): void {
    this.subscription.push(
      this.responsive
        .observe([Breakpoints.XSmall, Breakpoints.Small])
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((result) => {
          this.isMobileView = result.matches ? true : false;
        })
    );

    this.prequalService.previous_step$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((step) => {
        const prevStep = step;

        this.contents = this.contents.map((element) => {
          if (element.id === prevStep) {
            element.isStepComplete = true;
          }
          return element;
        });
      });
  }

  navigateToHome() {
    document.location.href = document.location.origin;
  }
}
